import { Box, Stack, Table, TableContainer, Typography } from '@mui/material';
import {
  rslMediaTypeData,
  rslDigitalVerticalData,
  rslDigitalSubverticalData,
} from '@features/benchmarks';
import { TableSection } from './TableSection';
import { BENCHMARK_INTRO } from './constants';

const footerSxProps = {
  fontStyle: 'italic',
} as const;

const BenchmarksRSL = () => (
  <Box id="help_benchmarks_rsl" className="tab-pane active" padding={1}>
    <p>{BENCHMARK_INTRO}</p>

    <Stack direction="column" padding="1rem">
      <TableContainer>
        <Table>
          <TableSection nameLabel="Media Type" data={rslMediaTypeData} />
          <TableSection
            nameLabel="Digital Vertical"
            data={rslDigitalVerticalData}
          />
          <TableSection
            nameLabel="Digital Sub Vertical"
            data={rslDigitalSubverticalData}
          />
        </Table>
      </TableContainer>
    </Stack>

    <Typography sx={{ marginTop: '0.5rem', ...footerSxProps }}>
      Individual campaign performance may vary
    </Typography>
    <Typography sx={footerSxProps}>
      * Directional with low sample size
    </Typography>
  </Box>
);

export default BenchmarksRSL;
